import { privateApi } from "@core/libs/axios/apiInstances";
import { handlePaginatedResponse } from "@core/libs/axios/serviceHandler";
import { MemberProjectSchema } from "@modules/project/portal/types";
import type {
  TMemberProject,
  TMemberProjectListData,
  TMemberProjectQueryParams,
} from "@modules/project/portal/types";

const mapMemberProject = (item: TMemberProject): TMemberProject => item;

export const getMemberProjects = async (
  workspaceId: string,
  params: TMemberProjectQueryParams,
  signal?: AbortSignal,
): Promise<TMemberProjectListData> => {
  return handlePaginatedResponse(
    privateApi.get(`/projects/${workspaceId}/project/`, { params, signal }),
    MemberProjectSchema,
    mapMemberProject,
  ) as Promise<TMemberProjectListData>;
};
